import type { DateOnly } from "@/shared/components/date-picker";
import { getMomentTz } from "@dexteel/mesf-core";
import type { Moment } from "moment";

const moment = getMomentTz();

export const toUtcDay = (day: Moment | DateOnly | null): Date | null => {
	if (day === null) return null;
	const dateOnly = typeof day === "string" ? day : day.format("YYYY-MM-DD");
	const parsed = moment.utc(dateOnly, "YYYY-MM-DD", true);
	return parsed.isValid() ? parsed.toDate() : null;
};
